const colors = {
	colorPrimary: '#0A264B',
	colorSecondary: '#C1C1BF',
	colorSuccess: '#45b649',
	colorDanger: '#c3151b',
	colorWarning: '#ffd700',
	colorInfo: '#00c9ff',
	colorTertiary: '#C1C1BF',
	colorSelected: '#ffd805',
};

export default colors;
